import React, { useState, useEffect, createContext, useContext } from 'react';
import Globals from './utils/Globals';
import Init from './utils/Init';

const APIContext = createContext<typeof Globals | null>(null);

const APIContextProvider = ({ children }) => {
    const [globals, setGlobals] = useState<typeof Globals | null>(null);
    useEffect(() => {
        async function fetchData() {
            const globals = await Init.init();
            setGlobals(globals);
        }
        fetchData();
    }, []);
    return globals == null ? null : <APIContext.Provider value={globals}>{children}</APIContext.Provider>;
};
export default APIContextProvider;

export function useAPI() {
    const context = useContext(APIContext);
    if (context === undefined) {
        throw new Error('Context must be used within a Provider');
    }
    return context;
}
